/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React from "react";
import { useLocation } from "react-router";
import { Link, NavLink } from "react-router-dom";
import SVG from "react-inlinesvg";
import { toAbsoluteUrl, checkIsActive } from "../../../../_helpers";
import { makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import ListItemText from '@material-ui/core/ListItemText';
import ListItem from '@material-ui/core/ListItem';
import List from '@material-ui/core/List';
import Divider from '@material-ui/core/Divider';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import CloseIcon from '@material-ui/icons/Close';
import Slide from '@material-ui/core/Slide';
import { SearchDropdown } from "../../extras/dropdowns/search/SearchDropdown";

const useStyles = makeStyles(theme => ({
  root: {
    backgroundColor: 'inherit!important',
    "& .MuiDialog-paperScrollPaper": {
      backgroundColor: '#1a1a27!important',

    }
  },
  appBar: {
    position: 'relative',
    backgroundColor: 'transparent'
  },
  title: {
    marginLeft: theme.spacing(2),
    flex: 1,
  },
}));

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="right" ref={ref} {...props} />;
});

export function AsideMenuList({ layoutProps }) {
  const location = useLocation();
  const getMenuItemActive = (url, hasSubmenu = false) => {
    return checkIsActive(location, url)
      ? ` ${!hasSubmenu &&
      "menu-item-active"} menu-item-open menu-item-not-hightlighted`
      : "";
  };

  const classes = useStyles();
  const [open, setOpen] = React.useState(false);

  function handleClickOpen() {
    setOpen(true);
  }

  function handleClose() {
    setOpen(false);
  }
  
  const dashboardLink = {
    pathname: "/dashboard",
    key: Math.random(),
    state: {
      applied: true
    }
  }
console.log(layoutProps.auth);
  return (
    <>
      {layoutProps.auth.simulate !== undefined &&
        <>
          <div style={{ color: "#ffffff", marginLeft: "24px" }}>Simulating: {layoutProps.auth.simulate.username}</div>
          <NavLink className="menu-link" to="/unsimulate">
            <span style={{ fontSize: "10px", marginLeft: "24px" }} className="menu-text">Stop simulating</span>
          </NavLink>
        </>
      }
      {/* begin::Menu Nav */}
      <ul className={`menu-nav ${layoutProps.ulClasses}`}>
        {/*begin::1 Level*/}
        <li
          className={`menu-item ${getMenuItemActive("/dashboard", false)}`}
          aria-haspopup="true"
        >
          <Link className="menu-link" to="">
          <span className="svg-icon menu-icon">
              <SVG src={toAbsoluteUrl("/media/menu/chart-line-solid.svg")} />
            </span>
            <span className="menu-text">Brandscan&#8482;</span>
          </Link>
        </li>
        <li
          className={`menu-item ${getMenuItemActive("/portal/products/macro", false)}`}
          aria-haspopup="true"
        >
          <NavLink className="menu-link" to="/portal/products/macro">
            <span className="svg-icon menu-icon">
              <SVG src={toAbsoluteUrl("/media/menu/laptop.svg")} />
            </span>
            <span className="menu-text">Actions</span>
          </NavLink>
        </li>
        {/* 
        <li
          className={`menu-item ${getMenuItemActive("/portal/products/macro/action", false)}`}
          aria-haspopup="true"
        >
          <NavLink className="menu-link" to="/portal/products/macro/action">
            <span className="svg-icon menu-icon">
              <SVG src={toAbsoluteUrl("/media/menu/laptop.svg")} />
            </span>
            <span className="menu-text">Global Action</span>
          </NavLink>
        </li>
         <li
          className={`menu-item ${getMenuItemActive("/portal/products/macro/check", false)}`}
          aria-haspopup="true"
        >
          <NavLink className="menu-link" to="/portal/products/macro/check">
            <span className="svg-icon menu-icon">
              <SVG src={toAbsoluteUrl("/media/menu/laptop.svg")} />
            </span>
            <span className="menu-text">Global Check</span>
          </NavLink>
        </li>
      */}

        <li
          className={`menu-item ${getMenuItemActive(
            "/portal/products"
          )}`}
          aria-haspopup="true"
        >
          <NavLink className="menu-link" to="/portal/products">
            <span className="svg-icon menu-icon">
              <SVG src={toAbsoluteUrl("/media/menu/box-solid.svg")} />
            </span>
            <span className="menu-text">Products</span>
          </NavLink>
        </li>
        <li
          className={`menu-item ${getMenuItemActive(
            "/portal/brands"
          )}`}
          aria-haspopup="true"
        >
          <NavLink className="menu-link" to="/portal/brands">
            <span className="svg-icon menu-icon">
              <SVG src={toAbsoluteUrl("/media/menu/tags-solid.svg")} />
            </span>
            <span className="menu-text">Brands</span>
          </NavLink>
        </li>
        <li
          className={`menu-item ${getMenuItemActive(
            "/portal/categories"
          )}`}
          aria-haspopup="true"
        >
          <NavLink className="menu-link" to="/portal/categories">
            <span className="svg-icon menu-icon">
              <SVG src={toAbsoluteUrl("/media/menu/layer-group-solid.svg")} />
            </span>
            <span className="menu-text">Categories</span>
          </NavLink>
        </li>
        <li
          className={`menu-item ${getMenuItemActive(
            "/portal/sellers"
          )}`}
          aria-haspopup="true"
        >
          <NavLink className="menu-link" to="/portal/sellers">
            <span className="svg-icon menu-icon">
              <SVG src={toAbsoluteUrl("/media/menu/comments-dollar-solid.svg")} />
            </span>
            <span className="menu-text">Sellers</span>
          </NavLink>
        </li>
        <li
          className={`menu-item ${getMenuItemActive(
            "/portal/reports"
          )}`}
          aria-haspopup="true"
        >
          <NavLink className="menu-link" to="/portal/reports">
            <span className="svg-icon menu-icon">
              <SVG src={toAbsoluteUrl("/media/menu/file-chart-line-solid.svg")} />
            </span>
            <span className="menu-text">Reports</span>
          </NavLink>
        </li>
        {/*end::1 Level*/}
        <li
          className={`menu-item ${getMenuItemActive(
            "/portal/search"
          )}`}
          aria-haspopup="true"
          style={{ bottom: "90px", position: "absolute" }}
        >
          <NavLink className="menu-link" to="#" onClick={handleClickOpen}>
            <span className="svg-icon menu-icon">
              <SVG src={toAbsoluteUrl("/media/svg/icons/General/Search.svg")} />
            </span>
            <span className="menu-text">Search</span>
          </NavLink>
          <Dialog className={classes.root} fullScreen open={open} onClose={handleClose} TransitionComponent={Transition}
            PaperProps={{
              style: {
                background: "inherit!important"
              },
            }}>
            <AppBar className={classes.appBar} style={{ background: 'transparent', boxShadow: 'none' }}>
              <Toolbar>
                <IconButton style={{ position: 'absolute', right: "20px", top: "20px", fill: "white" }} edge="start" color="white" onClick={handleClose} aria-label="Close">
                  <CloseIcon style={{ fill: "#F3F6F9" }} />
                </IconButton>
                <SearchDropdown onClose={handleClose} />
              </Toolbar>
            </AppBar>
          </Dialog>
        </li>
        <li
          className={`menu-item ${getMenuItemActive(
            "/user-profile"
          )}`}
          aria-haspopup="true"
          style={{ bottom: "45px", position: "absolute" }}
        >
          <NavLink className="menu-link" to="/user-profile">
            <span className="svg-icon menu-icon">
              <SVG src={toAbsoluteUrl("/media/svg/icons/General/User.svg")} />
            </span>
            <span className="menu-text">{layoutProps.auth.name}</span>
          </NavLink>
        </li>
        <li
          className={`menu-item ${getMenuItemActive(
            "/logout"
          )}`}
          aria-haspopup="true"
          style={{ bottom: "0", position: "absolute" }}
        >
          <NavLink className="menu-link" to="/logout">
            <span className="menu-text">Logout</span>
          </NavLink>
        </li>
      </ul>

      {/* end::Menu Nav */}
    </> 
  );
}
